const validMailSigns = /(.+)@(.+){2,}\.(.+){2,}/;

export default validMailSigns;
